export default {"src":"/_next/static/media/eventLeftArrowIcon.3b9285bb.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};